import { BehaviorSubject } from 'rxjs';

import { SINGLETON } from './internals/singleton';
import { Message } from './types';

export function getMessageChannel(): BehaviorSubject<Message | void> {
  return SINGLETON.MESSAGE_CHANNEL;
}
